import { render, staticRenderFns } from "./svgToLeft.vue?vue&type=template&id=21b633a1&"
import script from "./svgToLeft.vue?vue&type=script&lang=js&"
export * from "./svgToLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports